module.exports = __webpack_public_path__ + "static/og_image-4dc4c022142b22f844501ecdc7f85c67.png";